import { Component, EventEmitter, Input, OnInit, Output, OnChanges } from '@angular/core';
import { RmService } from '@bidi/common-services';
import debounce from 'lodash/debounce';
import * as filters from './filters';
import { ContentsLibraryServices } from './contents-library.services';

export interface SearchForm {
  q?: string;
  tags?: {
    [type: string]: string;
  };
}

@Component({
  selector: 'bidi-contents-library',
  templateUrl: './contents-library.component.html',
  styleUrls: ['./contents-library.component.scss']
})
export class ContentsLibraryComponent implements OnInit, OnChanges {
  @Input() params: SearchForm = {};
  @Input() libTitle: any;
  @Input() subtitle: any;
  @Input() themes: any;
  @Input() views: any;
  @Input() dateSelect: any;
  @Input() noPublicator: any;

  @Output() selection = new EventEmitter();
  @Output() close = new EventEmitter();
  @Output() openContentCustom = new EventEmitter();
  @Output() addTheme = new EventEmitter<boolean>();

  tabsOptions = [
    {
      title: 'Recursos',
      id: 'recursos'
    },
    {
      title: 'Secuencias',
      id: 'secuencias'
    }
  ];
  showTab;

  loading = false;
  showPreview = true;
  form: SearchForm;
  currentSelection = null;
  filters = filters;
  firstFilter = true;
  secondFilter = false;
  secondFilterText = 'Filtros Avanzados';

  private fetch = debounce(() => {
    this.loading = false;
    this.contentsLibraryServices.getResources({tags : Object.values(this.form.tags).filter(Boolean), q : this.form.q, limit: 300});
  }, 500);

  constructor (private rm: RmService, public contentsLibraryServices: ContentsLibraryServices) {
    this.toggleTabs(this.tabsOptions[0]);
  }

  ngOnChanges () {
    this.form = Object.assign({ q: '', tags: {} }, this.params);
    this.fetch();
  }

  ngOnInit () {
    // this.contentsLibraryServices;
  }

  simpleSearchInputChange() {
    if ( this.form.q.length >= 3 ) {
      this.loading = true;
      this.fetch();
    }
  }
  inputChange () {
    this.loading = true;
    this.fetch();
  }

  selectResource (resource) {
    this.currentSelection = resource;
  }

  submit () {
    this.selection.emit(this.currentSelection);
    this.currentSelection = null;
  }

  submit2 (r) {
    this.selection.emit(r);
    this.currentSelection = null;
  }

  newTheme(e) {
    this.addTheme.emit(e);
  }

  openFirstFilter () {
    this.firstFilter = !this.firstFilter;
  }

  toggleSecondFilter () {
    this.secondFilter = !this.secondFilter;
    if (!this.secondFilter) {
      this.secondFilterText = 'Filtros Avanzados';
      console.log('no');
    } else {
      this.secondFilterText = 'Ocultar filtros avanzados';
      console.log('si');
    }
  }

  toggleTabs(e) {
    this.showTab = e;
  }
}
